import { memo } from 'react';
import { HStack, Text, VStack } from 'components/ui';
import { OtherFileWrapper } from './other.styled';
import { MediaFileProps } from '../media-file.types';
import { useTheme } from 'styled-components/macro';

export const OtherFile = memo((props: MediaFileProps) => {
  const { file, view = 'full' } = props;
  const theme = useTheme();

  if (view === 'thumbnail') {
    return (
      <HStack
        center
        style={{
          backgroundColor: theme.colors.gray[400],
        }}
      >
        <Text color="white">.{file.extension}</Text>
      </HStack>
    );
  }

  return (
    <VStack center>
      <OtherFileWrapper>
        <Text variant="heading-4">.{file.extension}</Text>
        <Text variant="heading-4" truncate>
          {file.name}
        </Text>
      </OtherFileWrapper>

      <Text variant="body-16" color="gray.500">
        Скачайте файл для просмотра
      </Text>
    </VStack>
  );
});
